import chroma from "chroma-js";

export default function makeChromaScale(def) {
  return (
    chroma
      .scale(["white", ...Object.values(def).map(String), "black"])
      .mode("oklch")
      // .correctLightness()
      .domain([0, ...Object.keys(def).map(Number), 1000])
  );
}
